import styled from "styled-components";

export const Hr = styled.hr`
  border-top: 1px solid ${(props) => (props.themeContext.name === "light" ? "#ECF2F8" : "#404044")};
`;
